import * as Immutable from "immutable";

const CommentMap = Immutable.OrderedMap;

export default CommentMap;
